import type { MoodEntry } from '../../types/mood';

export const energetic: MoodEntry = {
  id: 'energetic',
  name: 'Energetic',
    synonyms: ['vibrant', 'dynamic', 'charged', 'alive', 'spirited', 'energized', 'lively', 'active', 'animated', 'vigorous', 'forceful', 'powerful', 'driven'],
    related: ['motivated', 'uplifted', 'confident', 'driven'],
    antonyms: ['lethargic', 'sluggish', 'apathetic', 'unmotivated', 'drained', 'dull', 'sluggish', 'tired', 'exhausted', 'drained', 'slow', 'apathetic', 'unmotivated', 'sluggish',
  'tired',
  'exhausted',
  'drained',
  'slow',
  'apathetic',
  'unmotivated',
  'lethargic',
  'flat',
  'heavy'],
    behaviours: ['quick movements', 'strong gestures', 'focused intensity', 'high engagement'],
    actions: ['start a new task', 'move your body', 'organise something fast', 'channel momentum into progress'],
    phrases: ['Lean into the momentum.', 'Let your energy carry you.', 'Move with intention.', 'You’re in motion — keep going.'],
    quotes: [
      '“Energy and persistence conquer all things.” — Benjamin Franklin',
      '“Passion is energy.” — Oprah Winfrey'
    ],
    palette: ['#FFD1DC', '#FF9AA2', '#FF6F91', '#FF4F6D'],
    season: 'Autumn'
};